<template>
  <div class="parent-field">
    <div class="left">
      <el-select
        v-if="!parent"
        v-model="selected"
        filterable
        :loading="loading"
        :disabled="curDisabled"
        placeholder="请选择或搜索"
        class="is-select"
        @change="selectChange('dropdown', $event)"
        @visible-change="selectExpand"
      >
        <el-option
          v-for="item in selectList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <template v-else>
        <div class="is-text">
          {{ parent.name }}
          <span v-if="!curDisabled" class="icon-close">
            <i class="el-icon-close" @click="selectChange('dropdown', null)"></i>
          </span>
        </div>
      </template>
    </div>
    <div class="right" :class="{ 'is-disabled': curDisabled }" @click="openRefDialog">
      <i class="el-icon-plus"></i>
    </div>
    <parent-table
      :project-id="projectId"
      :task-group="taskGroup"
      :task-level="taskLevel"
      :task-ids="[taskId]"
      :dialog-visible.sync="dialogVisible"
      @select="selectChange('dialog', $event)"
    ></parent-table>
  </div>
</template>

<script>
import ParentTable from "./ParentTable"
import * as TaskApi from "@/api/project/task"
import { getTaskLevel } from "@/utils/project"

export default {
  name: "parent-field",
  components: {
    ParentTable
  },
  props: {
    projectId: String,
    children: Array,
    parent: Object,
    taskGroup: Object,
    taskId: String,
    disabled: Boolean
  },
  data() {
    return {
      loading: false,
      selected: null,
      list: [],
      selectList: [],
      dialogVisible: false
    }
  },
  computed: {
    taskLevel() {
      return getTaskLevel(this.children)
    },
    curDisabled() {
      return this.disabled || this.taskLevel >= 3
    }
  },
  watch: {
    taskId() {
      this.list = []
    }
  },
  methods: {
    openRefDialog() {
      if (this.curDisabled) return
      this.dialogVisible = true
    },
    // 请求数据
    getTaskList() {
      this.list = []
      this.loading = true
      if (this.taskLevel >= 3) return
      TaskApi.getTaskList({
        ...this.searchItem,
        listType: "ALL",
        groupId: this.taskGroup?.id,
        page: 0,
        size: 20
      })
        .then(taskList => {
          let list = taskList.content
          list.forEach(task => {
            this.list.push(task)
            if (this.taskLevel === 1 && task.children?.length > 0) {
              task.children.forEach(children => {
                this.list.push(children)
              })
            }
          })
          this.selectList = this.list.filter(task => {
            return task.id !== this.taskId
          })
          this.listMap = this._.keyBy(this.list, "id")
        })
        .finally(() => (this.loading = false))
    },
    // 下拉菜单展开/收起
    selectExpand(visible) {
      if (visible) {
        if (this.list.length == 0) {
          this.getTaskList()
        }
      }
    },
    // 选择
    selectChange(from, selectedVal) {
      let parent
      if (!selectedVal) {
        this.$emit("set-parent", null)
        return
      }
      if (from === "dropdown") {
        parent = this.listMap[selectedVal]
      } else if (from === "dialog") {
        parent = selectedVal
      }
      this.$emit("set-parent", parent)
      this.searchText && (this.list = []) // 使再次展开下拉菜单时显示无搜索文字时的结果
      this.dialogVisible = false
      this.selected = null
    }
  }
}
</script>

<style lang="scss" scoped>
.parent-field {
  display: flex;
  align-items: center;
  height: 40px;
  .left {
    flex: auto;
    overflow: hidden;
    .is-select {
      ::v-deep .el-input__inner {
        border-radius: 4px 0 0 4px;
      }
    }
    .is-text {
      @include ellipsis;
      position: relative;
      height: 32px;
      line-height: 32px;
      padding-left: 11px;
      padding-right: 24px;
      border-radius: 4px 0 0 4px;
      border: 1px solid #d8dce6;
      box-sizing: border-box;
      color: $color-main;
      .icon-close {
        position: absolute;
        right: 2px;
        color: $color-font-second;
        .el-icon-close {
          padding: 4px;
          cursor: pointer;
          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
  .right {
    @include flex-center;
    min-width: 32px;
    height: 32px;
    background: $color-bg-select;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #d8dce6;
    border-left-width: 0;
    cursor: pointer;
    box-sizing: border-box;
    &:hover:not(.is-disabled) {
      color: $color-main;
    }
  }
}
</style>
